
import { defineComponent } from 'vue';
import TreeFile from './TreeFile.vue';
import TreeFolder from './TreeFolder.vue';
import { useCodeViewStore } from '../store';
import MountedExecute from '@/modules/packageCanvas/modules/MountedExecute.vue';
import { ITreeFile, ITreeFolder } from '@/codeGeneration/codeGen';

export default defineComponent({
  name: 'FileTreeExplorer',
  components: { TreeFile, TreeFolder, MountedExecute },
  data(): { cvStore: any } {
    return {
      cvStore: useCodeViewStore()
    };
  },
  methods: {
    reMount() {
      // const cvStore = useCodeViewStore();
      // cvStore.loadCodeFromPersistance();
      // if (cvStore.fileTreeRoot) this.fileTreeRoot = cvStore.fileTreeRoot;
    }
  },
  emits: {
    fileOpened(fileSelected: ITreeFile) {
      return fileSelected.type === 'file';
    }
  }
});
